<template>
  <div class="bg-white shadow-sm border border-slate-200 overflow-hidden">
    <div class="px-6 pt-2 pb-0.5">
      <div class="flex items-baseline gap-2 flex-wrap">
        <h2 class="text-base font-bold text-[#0d4169] text-left">
          {{ resolvedCompanyName }}
        </h2>
        <span class="text-sm font-bold text-slate-600">Withholding · Issue</span>
      </div>
    </div>

    <form @submit.prevent="saveEntry">
      <div class="px-3 pt-1.5 pb-4 bg-white">
        <div class="wh-entry-layout">
          <div class="wh-calendar-col">
            <label class="wh-calendar-label">Select Date:</label>
            <input
              v-model="calendarDate"
              type="date"
              class="wh-calendar-input"
              @change="onCalendarChange"
            >
          </div>

          <div class="wh-pad-col">
            <div class="wh-pad-sheet">
              <div class="wh-pad-row wh-pad-row-header">
                <div class="wh-pad-invoice-date">
                  <label class="wh-pad-label">Date</label>
                  <span class="wh-pad-value">{{ displayInvoiceDate }}</span>
                </div>
              </div>

              <div class="wh-pad-row">
                <div class="wh-pad-field">
                  <label class="wh-pad-label">Invoice No</label>
                  <input
                    v-model.trim="draft.invoiceNo"
                    type="text"
                    class="wh-pad-control"
                    autocomplete="off"
                  >
                </div>
                <div class="wh-pad-field">
                  <label class="wh-pad-label">Company name</label>
                  <input
                    v-model.trim="draft.companyName"
                    type="text"
                    class="wh-pad-control"
                    autocomplete="off"
                  >
                </div>
              </div>

              <div class="wh-pad-row">
                <div class="wh-pad-field">
                  <label class="wh-pad-label">TIN Number</label>
                  <input
                    v-model.trim="draft.tinNo"
                    type="text"
                    class="wh-pad-control"
                    autocomplete="off"
                  >
                </div>
                <div class="wh-pad-field">
                  <label class="wh-pad-label">FS Number</label>
                  <input
                    v-model.trim="draft.fsNo"
                    type="text"
                    class="wh-pad-control"
                    autocomplete="off"
                  >
                </div>
              </div>

              <div class="wh-pad-row">
                <div class="wh-pad-field">
                  <label class="wh-pad-label">Reason</label>
                  <input
                    v-model.trim="draft.reason"
                    type="text"
                    class="wh-pad-control"
                    autocomplete="off"
                  >
                </div>
                <div class="wh-pad-field">
                  <label class="wh-pad-label">Issue amount</label>
                  <input
                    v-model.number="draft.issueAmount"
                    type="number"
                    step="0.01"
                    min="0"
                    class="wh-pad-control wh-pad-control-num"
                  >
                </div>
              </div>

              <div class="wh-pad-row">
  <div class="wh-pad-field">
    <label class="wh-pad-label">Withhold 3%</label>
    <input
      v-model.number="draft.withhold3"
      type="number"
      step="0.01"
      min="0"
      class="wh-pad-control wh-pad-control-num"
      @input="onWithhold3Input"
    >
  </div>

  <div class="wh-pad-field">
    <label class="wh-pad-label">Withhold 30%</label>
    <input
      v-model.number="draft.withhold30"
      type="number"
      step="0.01"
      min="0"
      class="wh-pad-control wh-pad-control-num"
      @input="onWithhold30Input"
    >
  </div>
</div>

<div class="wh-pad-row">
  <div class="wh-pad-field">
    <label class="wh-pad-label">Remark/Invoice date</label>
    <input
      v-model.trim="draft.remarkInvoiceDate"
      type="text"
      class="wh-pad-control"
      autocomplete="off"
    >
  </div>

  <div class="wh-pad-field"></div>
</div>

              <!-- <div class="wh-pad-row wh-pad-row-total">
                <div class="wh-pad-field">
                  <label class="wh-pad-label wh-pad-label-total">Total Sales</label>
                  <span class="wh-pad-value wh-pad-value-total">{{ fmt(draftTotalSales) }}</span>
                </div>
                <div class="wh-pad-field wh-pad-field-spacer" aria-hidden="true"></div>
              </div> -->
            </div>

            <div class="flex justify-center pt-2 pb-0.5">
              <button
                v-if="editingId"
                type="submit"
                :disabled="!canEditWithholdingIssue || isSaving"
                class="min-w-max px-4 py-1 bg-[#0d4169] text-white text-[0.8125rem] font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                <div
                  v-if="isSaving"
                  class="h-4 w-4 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
                ></div>
                <span v-if="!isSaving">Update Changes</span>
              </button>
              <button
                v-else
                type="submit"
                :disabled="!canAddWithholdingIssue || isSaving"
                class="min-w-max px-4 py-1 bg-[#0d4169] text-white text-[0.8125rem] font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                <div
                  v-if="isSaving"
                  class="h-4 w-4 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
                ></div>
                <span v-if="!isSaving">Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="px-6 pb-12 pt-8 border-t border-slate-100 bg-slate-50/30">
      <div class="flex items-center gap-6">
        <div class="flex items-center gap-3 min-w-[220px]">
          <label class="text-[0.78rem] font-semibold text-[#1e293b] shrink-0">
            Start Date <span class="text-red-500">*</span>
          </label>
          <input
            v-model="filterStart"
            type="date"
            class="flex-1 min-w-[9rem] px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
            required
          >
        </div>
        <div class="flex items-center gap-3 min-w-[220px]">
          <label class="text-[0.78rem] font-semibold text-[#1e293b] shrink-0">End Date</label>
          <input
            v-model="filterEnd"
            type="date"
            class="flex-1 min-w-[9rem] px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
          >
        </div>
      </div>

      <div class="w-full overflow-auto custom-scrollbar wh-table-scroll-wrap pb-1">
        <table class="wh-issue-table wh-issue-list wh-issue-list-auto consumption-table-shell w-full min-w-max bg-white rounded-xl shadow-sm">
          <thead>
            <tr>
              <th class="col-sn">S/N</th>
              <th class="col-wh-expand">Company</th>
              <th class="num col-wh-num-50">Issue</th>
              <th class="num col-wh-num-50">Withhold 3%</th>
              <th class="num col-wh-num-50">Withhold 30%</th>
              <th class="col-wh-remark">Remark/Invoice date</th>
              <!-- <th class="num col-wh-num-50 bg-slate-50 font-semibold text-[#0d4169]">Total Sales</th> -->
              <th class="col-wh-action col-wh-action-th">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, idx) in entriesForDate"
              :key="row.id"
              class="hover:bg-slate-50 transition-colors border-b"
            >
              <td class="col-sn">{{ idx + 1 }}</td>
              <td class="col-wh-expand">{{ row.companyName || '—' }}</td>
              <td class="num col-wh-num-50">{{ fmt(row.issueAmount) }}</td>
              <td class="num col-wh-num-50">{{ fmt(row.withhold3) }}</td>
              <td class="num col-wh-num-50">{{ fmt(row.withhold30) }}</td>
              <td class="col-wh-remark">{{ row.remarkInvoiceDate || '—' }}</td>
              <!-- <td class="num col-wh-num-50 bg-slate-50 font-semibold text-[#0d4169]">{{ fmt(row.totalSales) }}</td> -->
              <td class="col-wh-action actions">
                <button
                  type="button"
                  :disabled="!canEditWithholdingIssue"
                  @click="startEdit(row)"
                >
                  Edit
                </button>
                <button type="button" class="actions-detail">Detail</button>
              </td>
            </tr>
            <tr v-if="isLoadingList">
              <td colspan="7" class="py-12 text-center text-slate-400 italic">Loading entries…</td>
            </tr>
            <tr v-else-if="entriesForDate.length === 0">
              <td colspan="7" class="py-12 text-center text-slate-400 italic">
                {{ filterStart ? 'No recorded entries found for the selected date range.' : 'Please select a Start Date to view entries.' }}
              </td>
            </tr>
          </tbody>
          <tfoot v-if="entriesForDate.length > 0">
            <tr class="footer-total font-semibold bg-slate-100/80 border-t border-slate-200">
              <td colspan="2">Total</td>
              <td class="num col-wh-num-50">{{ fmt(sumEntries('issueAmount')) }}</td>
              <td class="num col-wh-num-50">{{ fmt(sumEntries('withhold3')) }}</td>
              <td class="num col-wh-num-50">{{ fmt(sumEntries('withhold30')) }}</td>
              <td></td>
              <!-- <td class="num col-wh-num-50 text-[#0d4169]">{{ fmt(sumEntries('totalSales')) }}</td> -->
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <FinanceToast :show="toast.show" :variant="toast.variant">{{ toast.message }}</FinanceToast>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import FinanceToast from '../FinanceToast.vue'
import { apiFetch } from '../../../utils/api'

const store = useStore()

const currentUser = computed(() => store.getters.currentUser || store.state.user || {})

const userPrivileges = computed(() => {
  const raw = currentUser.value?.privilege
  if (!raw) return {}
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw)
    } catch {
      return {}
    }
  }
  return raw
})

const hasAllPrivilege = computed(() => {
  return userPrivileges.value?.All === true || userPrivileges.value?.all === true
})

function getPrivilegeEntry(key) {
  const priv = userPrivileges.value || {}
  if (!key) return null
  if (priv?.[key]) return priv[key]

  const normalizedNeedle = String(key).trim().toLowerCase()
  const foundKey = Object.keys(priv).find((k) => String(k).trim().toLowerCase() === normalizedNeedle)
  return foundKey ? priv[foundKey] : null
}

function getActionFlag(entry, action) {
  if (!entry || typeof entry !== 'object') return false
  if (!action) return false
  if (entry[action] !== undefined) return !!entry[action]

  const a = String(action)
  const candidates = [
    a.toLowerCase(),
    a.toUpperCase(),
    a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()
  ]
  for (const k of candidates) {
    if (entry[k] !== undefined) return !!entry[k]
  }
  return false
}

const canAddWithholdingIssue = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry('Withholding Issue'), 'Add')
})

const canEditWithholdingIssue = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry('Withholding Issue'), 'Edit')
})

const resolvedCompanyName = computed(() => {
  const user = currentUser.value
  return (
    user?.company?.name ||
    user?.companyName ||
    user?.company_name ||
    user?.company?.company_name ||
    'Company Name'
  )
})

function todayISO() {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const calendarDate = ref('')
const filterStart = ref(todayISO())
const filterEnd = ref('')
const editingId = ref(null)
const isSaving = ref(false)
const isLoadingList = ref(false)
const entriesForDate = ref([])

const draft = reactive({
  invoiceNo: '',
  companyName: '',
  tinNo: '',
  reason: '',
  issueAmount: '',
  withhold3: '',
  withhold30: '',
  fsNo: '',
  remarkInvoiceDate: ''
})

const toast = reactive({ show: false, message: '', variant: 'success' })

const displayInvoiceDate = computed(() => formatDisplayDate(calendarDate.value))

function formatDisplayDate(iso) {
  if (!iso || typeof iso !== 'string') return '—'
  const parts = iso.split('-')
  if (parts.length !== 3) return iso
  const [y, m, d] = parts
  return `${d}/${m}/${y}`
}

function n(v) {
  const x = Number(v)
  return Number.isFinite(x) ? x : 0
}

function fmt(x) {
  return n(x).toFixed(2)
}

function onWithhold3Input() {
  if (n(draft.withhold3) !== 0) {
    draft.withhold30 = 0
  }
}

function onWithhold30Input() {
  if (n(draft.withhold30) !== 0) {
    draft.withhold3 = 0
  }
}

// const draftTotalSales = computed(() => n(draft.issueAmount) + n(draft.withhold3) + n(draft.withhold30))

async function loadEntries() {
  if (!filterStart.value) {
    entriesForDate.value = []
    return
  }
  const end = filterEnd.value || filterStart.value
  isLoadingList.value = true
  try {
    const params = new URLSearchParams({
      startDate: filterStart.value,
      endDate: end
    })
    const res = await apiFetch(`/finance/withholding-issue?${params}`)
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      showToast(err.message || 'Failed to load entries.', 5000, 'error')
      entriesForDate.value = []
      return
    }
    const data = await res.json().catch(() => [])
    entriesForDate.value = Array.isArray(data) ? data : []
  } catch {
    showToast('Failed to load entries.', 5000, 'error')
    entriesForDate.value = []
  } finally {
    isLoadingList.value = false
  }
}

function sumEntries(key) {
  return entriesForDate.value.reduce((a, r) => a + n(r[key]), 0)
}

let toastTimer = null
function showToast(message, durationMs = 1600, variant = 'success') {
  if (toastTimer) {
    clearTimeout(toastTimer)
    toastTimer = null
  }
  toast.message = message
  toast.variant = variant
  toast.show = true
  toastTimer = window.setTimeout(() => {
    toast.show = false
    toastTimer = null
  }, durationMs)
}

function resetDraft() {
  editingId.value = null
  draft.invoiceNo = ''
  draft.companyName = ''
  draft.tinNo = ''
  draft.reason = ''
  draft.issueAmount = ''
  draft.withhold3 = ''
  draft.withhold30 = ''
  draft.fsNo = ''
  draft.remarkInvoiceDate = ''
}

function onCalendarChange() {
  resetDraft()
  filterStart.value = calendarDate.value
  filterEnd.value = ''
}

function startEdit(row) {
  if (!canEditWithholdingIssue.value) return
  editingId.value = row.id
  draft.invoiceNo = row.invoiceNo || ''
  draft.companyName = row.companyName || ''
  draft.tinNo = row.tinNo || ''
  draft.reason = row.reason || ''
  draft.issueAmount = n(row.issueAmount)
  draft.withhold3 = n(row.withhold3)
  draft.withhold30 = n(row.withhold30)
  if (n(draft.withhold3) !== 0 && n(draft.withhold30) !== 0) {
    draft.withhold30 = 0
  }
  draft.fsNo = row.fsNo || ''
  draft.remarkInvoiceDate = row.remarkInvoiceDate || ''
}

async function saveEntry() {
  if (isSaving.value) return
  if (editingId.value != null) {
    if (!canEditWithholdingIssue.value) return
  } else if (!canAddWithholdingIssue.value) {
    return
  }
  const companyName = String(draft.companyName || '').trim()
  const invoiceNo = String(draft.invoiceNo || '').trim()
  if (!companyName && !invoiceNo) {
    showToast('Enter company name or invoice number.', 1600, 'error')
    return
  }

  const body = {
    invoiceDate: calendarDate.value,
    invoiceNo,
    companyName,
    tinNo: String(draft.tinNo || '').trim(),
    reason: String(draft.reason || '').trim(),
    issueAmount: n(draft.issueAmount),
    withhold3: n(draft.withhold3),
    withhold30: n(draft.withhold30),
    fsNo: String(draft.fsNo || '').trim(),
    remarkInvoiceDate: String(draft.remarkInvoiceDate || '').trim() || null
  }

  isSaving.value = true
  try {
    if (editingId.value != null) {
      const res = await apiFetch(`/finance/withholding-issue/${editingId.value}`, {
        method: 'PUT',
        body: JSON.stringify(body)
      })
      if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        showToast(err.message || 'Failed to update entry.', 5000, 'error')
        return
      }
      showToast('Entry updated successfully.')
      resetDraft()
      await loadEntries()
      return
    }

    const res = await apiFetch('/finance/withholding-issue', {
      method: 'POST',
      body: JSON.stringify(body)
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      showToast(err.message || 'Failed to save entry.', 5000, 'error')
      return
    }
    showToast('Entry saved successfully.')
    resetDraft()
    await loadEntries()
  } catch {
    showToast('Failed to save entry.', 5000, 'error')
  } finally {
    isSaving.value = false
  }
}

watch([filterStart, filterEnd], () => {
  loadEntries()
})

onMounted(() => {
  loadEntries()
})
</script>

<style scoped>
/* Entry row: calendar (auto width) + pad form (remaining space) */
.wh-entry-layout {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem 1.25rem;
}

.wh-calendar-col {
  flex: 0 0 auto;
  width: fit-content;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  padding-top: 0.15rem;
}

.wh-calendar-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
}

.wh-calendar-input {
  width: auto;
  min-width: 9rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  outline: none;
  font-size: 0.875rem;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s;
}

.wh-calendar-input:focus {
  border-color: #0d4169;
}

.wh-pad-col {
  flex: 1 1 18rem;
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

/* Entry form — borders match calendar field */
.wh-pad-sheet {
  --wh-control-w: 10.5rem;
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.78rem;
  color: #1e293b;
  background: linear-gradient(180deg, #faf8f4 0%, #f3f1eb 100%);
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  padding: 0.5rem 0.65rem;
  box-sizing: border-box;
  width: 100%;
  max-width: 52rem;
}

.wh-pad-row-header {
  justify-content: flex-end;
  padding-top: 0;
  padding-bottom: 0.35rem;
  margin-bottom: 0.15rem;
  border-bottom: 1px solid #e2e8f0;
}

.wh-pad-invoice-date {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  margin-left: auto;
}

.wh-pad-row:not(.wh-pad-row-header) {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 0.5rem 0.75rem;
  padding: 0.3rem 0;
}

.wh-pad-row:not(.wh-pad-row-header):not(.wh-pad-row-total) {
  column-gap: 1.75rem;
}

.wh-pad-row.wh-pad-row-three {
  grid-template-columns: 1fr 1fr 1fr;
}

.wh-pad-row.wh-pad-row-three .wh-pad-label {
  white-space: normal;
  line-height: 1.15;
  max-width: 5.5rem;
}

.wh-pad-row:not(.wh-pad-row-header):last-child {
  padding-bottom: 0.1rem;
}

.wh-pad-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  min-width: 0;
}

.wh-pad-field-spacer {
  visibility: hidden;
  pointer-events: none;
  min-height: 1.5rem;
}

.wh-pad-label {
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  text-align: right;
}

.wh-pad-label-total {
  color: #0d4169;
}

.wh-pad-control {
  flex: 0 0 var(--wh-control-w);
  width: var(--wh-control-w);
  min-width: var(--wh-control-w);
  max-width: var(--wh-control-w);
  padding: 0.22rem 0.4rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.125rem;
  outline: none;
  font-size: 0.8125rem;
  line-height: 1.25;
  min-height: 1.5rem;
  color: #1e293b;
  background: #fff;
  box-sizing: border-box;
  text-align: right;
  transition: border-color 0.15s;
}

.wh-pad-control:focus {
  border-color: #0d4169;
}

.wh-pad-control-num {
  font-variant-numeric: tabular-nums;
}

.wh-pad-value {
  flex: 0 0 var(--wh-control-w);
  width: var(--wh-control-w);
  min-width: var(--wh-control-w);
  max-width: var(--wh-control-w);
  min-height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.22rem 0.4rem;
  box-sizing: border-box;
  font-size: 0.8125rem;
  line-height: 1.25;
  font-weight: 600;
  color: #334155;
  font-variant-numeric: tabular-nums;
  text-align: right;
  background: transparent;
  border: none;
}

.wh-pad-value-total {
  font-weight: 700;
  color: #0d4169;
}

.wh-pad-control[type='number']::-webkit-inner-spin-button,
.wh-pad-control[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.wh-pad-control[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

@media (max-width: 767.98px) {
  .wh-entry-layout {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .wh-pad-col {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
  }

  .wh-pad-sheet {
    width: 100%;
    max-width: 100%;
  }

  /* Phone: one field per row; caption above control */
  .wh-pad-row:not(.wh-pad-row-header) {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 0.65rem;
  }

  .wh-pad-row-header {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }

  /* Invoice date: one row, label left / value right across full width */
  .wh-pad-invoice-date {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 1.25rem;
    margin-left: 0;
    width: 100%;
    max-width: 100%;
  }

  .wh-pad-invoice-date .wh-pad-label {
    text-align: left;
    width: auto;
  }

  .wh-pad-invoice-date .wh-pad-value {
    flex: 0 0 auto;
    width: auto;
    min-width: 0;
    max-width: none;
    margin-left: auto;
    text-align: right;
    justify-content: flex-end;
    padding-left: 0;
  }

  .wh-pad-field {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 0.25rem;
    width: 100%;
  }

  .wh-pad-label {
    text-align: left;
    width: 100%;
  }

  .wh-pad-control,
  .wh-pad-value {
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

  .wh-pad-control {
    text-align: left;
  }

  .wh-pad-value {
    justify-content: flex-start;
    text-align: left;
    padding-left: 0;
  }

  .wh-pad-field-spacer {
    display: none;
  }

  .wh-calendar-col {
    width: 100%;
  }

  .wh-calendar-input {
    width: 100%;
    max-width: 100%;
  }
}

/* List table */
.wh-issue-table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.75rem;
  color: #1e293b;
}

.consumption-table-shell {
  border-collapse: collapse;
}

.wh-table-scroll-wrap {
  padding-top: 20px;
  box-sizing: border-box;
}

.wh-issue-table th,
.wh-issue-table td {
  padding: 3px 6px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
  font-size: 0.72rem;
  line-height: 1.2;
}

.wh-issue-table thead th {
  cursor: default;
}

.wh-issue-table th {
  background: #f1f5f9;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 20;
}

.wh-issue-table th.num,
.wh-issue-table td.num {
  text-align: center;
  white-space: nowrap;
}

.wh-issue-table.wh-issue-list.wh-issue-list-auto {
  table-layout: auto;
  width: auto;
  min-width: 100%;
}

.wh-issue-list-auto th,
.wh-issue-list-auto td {
  width: auto;
  min-width: max(2.25rem, min-content);
  max-width: none;
  box-sizing: border-box;
}

.wh-issue-list-auto thead th {
  white-space: nowrap;
}

.wh-issue-list-auto .col-wh-expand {
  min-width: max(6rem, max-content);
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: left;
}

.wh-issue-list-auto .col-wh-remark {
  min-width: max(7rem, max-content);
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: left;
}

.wh-issue-list tbody tr:hover {
  background: #f1f5f9;
}

@media (min-width: 1024px) {
  table.wh-issue-list.wh-issue-list-auto {
    table-layout: auto;
    width: auto;
    min-width: 100%;
  }

  table.wh-issue-list.wh-issue-list-auto .col-sn {
    width: auto;
    min-width: max(2rem, max-content);
    text-align: center;
    white-space: nowrap;
  }

  table.wh-issue-list.wh-issue-list-auto thead th.col-wh-expand {
    white-space: nowrap;
  }

  table.wh-issue-list.wh-issue-list-auto .col-wh-expand {
    width: auto;
    min-width: max(8rem, max-content);
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    text-align: left;
  }

  table.wh-issue-list.wh-issue-list-auto tbody td.col-wh-expand {
    word-break: normal;
    overflow-wrap: break-word;
  }

  table.wh-issue-list.wh-issue-list-auto .col-wh-action {
    width: auto;
    min-width: max(5.25rem, max-content);
    max-width: none;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
  }

  table.wh-issue-list.wh-issue-list-auto th.col-wh-action-th {
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
  }
}

@media (max-width: 1023.98px) {
  table.wh-issue-list .col-sn {
    white-space: nowrap;
    text-align: center;
    min-width: 2rem;
  }

  table.wh-issue-list.wh-issue-list-auto .col-wh-expand {
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    min-width: 9rem;
  }

  table.wh-issue-list.wh-issue-list-auto thead th.col-wh-expand {
    white-space: nowrap;
  }

  table.wh-issue-list.wh-issue-list-auto thead th.col-wh-expand,
  table.wh-issue-list.wh-issue-list-auto tbody td.col-wh-expand {
    text-align: left;
  }

  table.wh-issue-list th.num,
  table.wh-issue-list td.num {
    white-space: nowrap;
  }

  table.wh-issue-list .col-wh-action,
  table.wh-issue-list td.actions {
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.actions button {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.78rem;
  padding: 0;
  display: flex;
  align-items: center;
}

.actions button:disabled {
  color: #94a3b8;
  cursor: not-allowed;
  text-decoration: none;
}

.actions button.actions-detail {
  color: #0d4169;
  text-decoration: none;
  font-weight: 700;
}

.actions button.actions-detail:hover {
  color: #0a3354;
  text-decoration: underline;
}

.footer-total td {
  font-size: 0.72rem;
  padding-top: 4px;
  padding-bottom: 4px;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
